import React, { useEffect, useRef } from 'react';

interface AutoSaveProps {
  showToast: boolean;
  onSaveDraft: () => void;
}

const AutoSaveFormik = (
  props: AutoSaveProps,
  { timeout = 30000 }
): React.ReactElement => {
  const { onSaveDraft, showToast } = props;

  const isMountedRef = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Updates state based on form value changes
  useEffect(() => {
    if (!showToast && isMountedRef.current) {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        onSaveDraft();
      }, timeout);
    }
    isMountedRef.current = true;
  }, [onSaveDraft, showToast, timeout]);

  return <></>;
};

export default AutoSaveFormik;
